import { render } from "./client_requested_services.html?vue&type=template&id=46d253f4&external"
import script from "./client_requested_services.js?vue&type=script&lang=js&external"
export * from "./client_requested_services.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__